module.exports = __webpack_public_path__ + "static/img/xyrb.cd285fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xyrb.png
// module id = ZA0a
// module chunks = 7